import PostLoad from "./PostLoad";

export default PostLoad;